<template>
    <div>
        <app-layout>
            <template v-slot:header>
                <Header :title="$t('minor_applications') + ' - ' + $t('prep_school')" :actions="subMenu"
                    @filter-div-status="datatable.filterStatus = $event" :isColumns="true">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                :unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </Header>
            </template>
            <template v-slot:header-mobile>
                <HeaderMobile :title="$t('minor_applications') + ' - ' + $t('prep_school')" :actions="subMenu"
                    @filter-div-status="datatable.filterStatus = $event" :isColumns="true">
                    <template v-slot:columns>
                        <div class="mb-1" v-for="(column, key) in datatable.columns" :key="key">
                            <b-form-checkbox :id="'checkbox-' + key" :name="'checkbox-' + key" :value="false"
                                :unchecked-value="true" v-model="column.hidden" v-if="column.field != 'buttons'">
                                {{ column.label }}
                            </b-form-checkbox>
                        </div>
                    </template>
                </HeaderMobile>
            </template>
            <datatable-filter v-show="datatable.filterStatus" @filter="filter" @filterClear="filterClear"
            :exportExcel="true" @exportExcel="exportExcel(datatable.queryParams)">
                <b-row>
                    <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('period') + ' / ' + $t('semester')">
                            <semesters-selectbox v-model="datatable.queryParams.filter.semester_id
                                "></semesters-selectbox>
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('student_number')">
                            <b-form-input v-model="datatable.queryParams.filter.student_number
                                " />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('name')">
                            <b-form-input v-model="datatable.queryParams.filter.name" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('surname')">
                            <b-form-input v-model="datatable.queryParams.filter.surname" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('faculty')">
                            <faculty-selectbox v-model="datatable.queryParams.filter.to_faculty
                                " />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('program')">
                            <program-selectbox :faculty_code="datatable.queryParams.filter.to_faculty
                                " v-model="datatable.queryParams.filter.to_program" />
                        </b-form-group>
                    </b-col>
                    <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="minor_application_statuses"
                                v-model="datatable.queryParams.filter.status" />
                        </b-form-group>
                    </b-col>
                    <!-- <b-col sm="12" md="6" lg="4">
                        <b-form-group :label="$t('status')">
                            <parameter-selectbox code="minor_application_statuses"
                                v-model="datatable.queryParams.filter.status" />
                        </b-form-group>
                    </b-col> -->
                </b-row>
            </datatable-filter>
            <datatable :isLoading.sync="datatable.isLoading" :columns="datatable.columns" :rows="datatable.rows"
                :total="datatable.total" :queryParams="datatable.queryParams" :lineNumbers="false"
                @on-page-change="onPageChange" @on-sort-change="onSortChange" @on-per-page-change="onPerPageChange"
                v-show="datatable.showTable">
            </datatable>
            <CommonModal ref="detailFormModal" size="xxl" :onHideOnlyX="true" @bHideModalHeaderClose="formClear()">
                <template v-slot:CommonModalTitle>
                    {{ $t("detail").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <detail-form v-model="formData" :type="formType" @getItem="getItem"
                        v-if="formProcess == 'detail' && formId > -1" />
                </template>
            </CommonModal>
            <CommonModal ref="updateStatusFormModal" size="md" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t("application_status_update").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-row>
                        <b-col cols="12">
                            <ValidationObserver ref="updateFormValid">
                                <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('status')">
                                        <b-form-select :validate-error="errors[0]" v-model="update.status"
                                            :options="updateOptions">
                                        </b-form-select>
                                    </b-form-group>
                                </ValidationProvider>
                            </ValidationObserver>
                        </b-col>
                        <b-col cols="6">
                            <button class="btn btn-secondary" @click="$refs.updateStatusFormModal.$refs.commonModal.hide()">
                                {{ $t("close") }}
                            </button>
                        </b-col>
                        <b-col cols="6">
                            <button class="btn btn-primary float-right" @click="updateStatus">
                                {{ $t("save") }}
                            </button>
                        </b-col>
                    </b-row>
                </template>
            </CommonModal>
            <CommonModal ref="declineFormModal" size="md" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t("reject").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-row>
                        <b-col cols="12">
                            <ValidationObserver ref="rejectFormValid">
                                <ValidationProvider name="cancel_reason" rules="required" v-slot="{ valid, errors }">
                                    <b-form-group :label="$t('cancel_reason')">
                                        <b-form-input :validate-error="errors[0]" v-model="explanation">
                                        </b-form-input>
                                    </b-form-group>
                                </ValidationProvider>
                            </ValidationObserver>
                        </b-col>
                        <b-col cols="6">
                            <button class="btn btn-secondary" @click="$refs.declineFormModal.$refs.commonModal.hide()">
                                {{ $t("close") }}
                            </button>
                        </b-col>
                        <b-col cols="6">
                            <button class="btn btn-danger float-right" @click="deleteConfirm">
                                {{ $t("reject") }}
                            </button>
                        </b-col>
                    </b-row>
                </template>
            </CommonModal>
            <CommonModal ref="notEntryModal" size="md" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t("grade_entry").toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <b-row align-v="center">
                        <b-col cols="12" v-if="note.en.status">
                            <b-form-group :label="$t('english')">
                                <b-form-input type="number" v-model="note.en.value">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12" v-if="note.tr.status">
                            <b-form-group :label="$t('turkish')">
                                <b-form-input type="number" v-model="note.tr.value">
                                </b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col cols="12">
                            <button class="btn btn-primary float-right" @click="noteSend">
                                {{ $t("save") }}
                            </button>
                        </b-col>
                    </b-row>
                </template>
            </CommonModal>
            <CommonModal ref="messageModal" :onHideOnlyX="true">
                <template v-slot:CommonModalTitle>
                    {{ $t('bulk_message').toUpper() }}
                </template>
                <template v-slot:CommonModalContent>
                    <message-form @send="sendMessage" />
                </template>
            </CommonModal>
        </app-layout>
    </div>
</template>
<script>
// Template
import AppLayout from "@/layouts/AppLayout";
import Header from "@/layouts/AppLayout/Header";
import HeaderMobile from "@/layouts/AppLayout/HeaderMobile";

// Component
import DatatableFilter from "@/components/datatable/DatatableFilter";
import Datatable from "@/components/datatable/Datatable";
import CommonModal from "@/components/elements/CommonModal";
import SemestersSelectbox from "@/components/interactive-fields/SemestersSelectbox";
import FacultySelectbox from "@/components/interactive-fields/FacultySelectbox";
import ProgramSelectbox from "@/components/interactive-fields/ProgramSelectbox";
import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";

// Pages
import DetailForm from "./DetailForm";

// Service
import MinorApplicationService from "@/services/MinorApplicationService";

// Other
import qs from "qs";

import { exportExcel } from "../function"

export default {
    name: "MinorApplicationsAdmin",
    components: {
        AppLayout,
        Header,
        HeaderMobile,
        DatatableFilter,
        Datatable,
        CommonModal,
        SemestersSelectbox,
        FacultySelectbox,
        ProgramSelectbox,
        ParameterSelectbox,
        DetailForm,
        MessageForm: () => import('./MessageForm'),
    },
    metaInfo() {
        return {
            title: this.$t("minor_applications") + " - " + this.$t('prep_school'),
        };
    },
    data() {
        return {
            exportExcel,
            formId: -1,
            noteId: -1,
            formData: {},
            formType: "",
            explanation: "",
            rejectId: -1,
            note: {
                en: { status: false },
                tr: { status: false },
            },
            formProcess: null,
            update: {
                minor_application_id: -1,
                status: null,
            },
            updateOptions: [
                { text: this.$t('minor_status_obj.waiting'), value: 'waiting' },
                { text: this.$t('minor_status_obj.waiting_prep_school'), value: 'waiting_prep_school' },
                { text: this.$t('minor_status_obj.waiting_academic_unit_office'), value: 'waiting_academic_unit_office' }
            ],
            subMenu: [
                {
                    text: this.$t('bulk_message'),
                    class: 'ri-device-recover-line',
                    callback: () => {
                        this.$refs.messageModal.$refs.commonModal.show()
                    }
                },
            ],
            datatable: {
                isLoading: false,
                columns: [
                    {
                        label: "",
                        field: "buttons",
                        html: true,
                        sortable: false,
                        tdClass: "p-0 text-center w-40 align-middle",
                        buttons: [
                            {
                                text: this.$t("detail"),
                                class: "ri-edit-box-line",
                                callback: (row) => {
                                    this.showDetail(row.id, row);
                                },
                            },
                            {
                                text: this.$t("grade_entry"),
                                class: "ri-booklet-line",
                                callback: (row) => {
                                    this.updateApplication(row);
                                },
                            },
                        ],
                    },
                    {
                        label: this.$t("id"),
                        field: "id",
                        sortable: false,
                        hidden: true,
                    },
                    {
                        label: this.$t("period") + " / " + this.$t("semester"),
                        field: "semester",
                        sortable: false,
                        hidden: false,
                        formatFn: (value, row) => {
                            return (
                                row.academic_year +
                                "<br>" +
                                this.getSemester(value)
                            );
                        },
                    },
                    {
                        label: this.$t("student"),
                        field: "student_number",
                        sortable: false,
                        hidden: false,
                        formatFn: (value, row) => {
                            return (
                                row.student_number +
                                "<br>" +
                                row.name +
                                " " +
                                row.surname +
                                "<br>" +
                                row.faculty_name +
                                "<br>" +
                                row.program_name
                            );
                        },
                    },
                    {
                        label: this.$t("class"),
                        field: "class",
                        sortable: false,
                        hidden: false,
                    },
                    {
                        label: this.$t("registration_date"),
                        field: "registration_date",
                        sortable: false,
                        hidden: false,
                    },
                    {
                        label: this.$t("prep_status"),
                        field: "prep_status_text",
                        sortable: false,
                        hidden: false,
                    },

                    {
                        label: this.$t("preferences").toUpper(),
                        field: "minor_application_preferences",
                        sortable: false,
                        hidden: false,
                        formatFn: (value) => {
                            let html = "";
                            if (value.length > 0) {
                                html += '<ol class="pl-2 m-0">';
                                value.forEach((item) => {
                                    html +=
                                        "<li>" +
                                        item.faculty_name +
                                        "<br>" +
                                        item.program_name +
                                        "</li>";
                                });
                                html += "</ol>";
                            }

                            return html;
                        },
                    },
                    {
                        label: this.$t("result").toUpper(),
                        field: "result",
                        sortable: false,
                        hidden: false,
                        formatFn: (value, row) => {
                            if (!row.result) return '-'
                            let variant = ['placed', 'other_preference_placed'].includes(row.result) ? 'badge-success'
                                : row.result == 'not_placed' ? 'badge-danger' : 'badge-warning'

                            return (
                                `<span class="badge ${variant}">${this.$t(`application_result.${row.result}`)}</span>`);
                        },
                    },
                    {
                        label: this.$t("status").toUpper(),
                        field: "status",
                        sortable: false,
                        hidden: false,
                        formatFn: (value, row) => {
                            let variant = "badge-light";
                            if (value.includes("waiting"))
                                variant = "badge-warning";
                            else if (value == "declined")
                                variant = "badge-danger";
                            else if (value == "student_affairs_declined")
                                variant = "badge-danger";
                            else if (value == "approved")
                                variant = "badge-success";

                            return (
                                '<span class="badge ' +
                                variant +
                                '">' +
                                row.status_text +
                                "</span>"
                            );
                        },
                    },
                    {
                        label: this.$t("explanation").toUpper(),
                        field: "explanation",
                        hidden: false,
                        formatFn: (value) => {
                            return value || "-"
                        },
                    },
                ],
                rows: [],
                total: 0,
                filterStatus: true,
                showTable: false,
                queryParams: {
                    filter: {},
                    sort: "id",
                    page: 1,
                    limit: 20,
                },
            },
        };
    },
    methods: {
        getItem(id) {
            MinorApplicationService.minorApplicationGetId(id)
                .then((response) => {
                    this.formData = response.data.data;
                })
        },
        filter() {
            this.getRows();
        },
        filterClear() {
            this.datatable.queryParams.filter = {};
            this.getRows();
        },
        onPageChange(params) {
            this.datatable.queryParams.page = params.currentPage;
            this.getRows();
        },
        onPerPageChange(params) {
            this.datatable.queryParams.limit = params.currentPerPage;
            this.datatable.queryParams.page = 1;
            this.getRows();
        },
        onSortChange(params) {
            const sortType = params[0].type == "desc" ? "-" : "";
            this.datatable.queryParams.sort = sortType + params[0].field;
            this.getRows();
        },
        async updateStatus() {
            const valid = await this.$refs['updateFormValid'].validate()
            if (!valid) {
                return
            }

            const response = await MinorApplicationService.studentAffairsUpdateApplicationStatus(this.update)
                .catch(e => this.$toast.error(this.$t('api.' + e.data.message)))

            if (response.data.success) {
                this.$refs.updateStatusFormModal.$refs.commonModal.hide()
                this.update = {}
            }
            this.$toast.success(this.$t('api.' + response.data.message));
        },
        getRows() {
            this.datatable.showTable = true;
            this.datatable.isLoading = true;

            const config = {
                params: {
                    ...this.datatable.queryParams,
                },
                paramsSerializer: (params) =>
                    qs.stringify(params, { encode: false }),
            };

            return MinorApplicationService.prepSchoolIndex(config)
                .then((response) => {
                    this.datatable.rows = response.data.data;
                    this.datatable.total = response.data.pagination.total;

                    if (this.formId > -1) {
                        const find = response.data.data.find(item => item.id === this.formId)
                        if (!find) return
                        this.formData = find
                    }
                })
                .finally(() => {
                    this.datatable.isLoading = false;
                });
        },
        async updateApplication(row) {
            this.$refs.notEntryModal.$refs.commonModal.show()
            this.noteId = row.id

            this.note.en.value = (row.prep_scores.en)
            this.note.tr.value = (row.prep_scores.tr)

            if ('en' in row.prep_scores) {
                this.note.en.status = true
            }
            if ('tr' in row.prep_scores) {
                this.note.tr.status = true
            }
        },
        async deleteConfirm() {
            const valid = await this.$refs.rejectFormValid.validate()
            if (!valid) {
                return
            }
            this.$swal
                .fire({
                    text: this.$t("are_you_sure_to_reject"),
                    showCancelButton: true,
                    confirmButtonText: this.$t("yes"),
                    cancelButtonText: this.$t("no"),
                    icon: "question",
                })
                .then((result) => {
                    if (result.isConfirmed) {
                        MinorApplicationService.studentAffairsDecline({
                            minor_application_id: this.rejectId,
                            explanation: this.explanation,
                        })
                            .then((response) => {
                                this.getRows();
                                this.$refs.declineFormModal.$refs.commonModal.hide();
                                this.$toast.success(this.$t('api.' + response.data.message));
                            })
                            .catch((e) => {
                                this.showErrors(e);
                            });
                    }
                });
        },
        delete(id) {
            this.rejectId = id;
            this.explanation = "";
            this.$refs.declineFormModal.$refs.commonModal.show();
        },
        async noteSend() {
            const data = {
                minor_application_id: this.noteId,
                prep_scores: {}
            }

            if (this.note.en.status) {
                data.prep_scores.en = Number(this.note.en.value)
                if (data.prep_scores.en == 0) {
                    data.prep_scores.en = null
                }
            }
            if (this.note.tr.status) {

                data.prep_scores.tr = Number(this.note.tr.value)
                if (data.prep_scores.tr == 0) {
                    data.prep_scores.tr = null
                }
            }

            const response = await MinorApplicationService.prepSchoolApprove(data)
                .catch(e => this.$toast.error(this.$t('api.' + e.data.message)))

            if (response.data.success) {
                this.$refs.notEntryModal.$refs.commonModal.hide()
                this.getRows();
            }
            this.$toast.success(this.$t('api.' + response.data.message));
        },
        formClear() {
            this.formId = null;
            this.formData = {};
            this.formProcess = null;
        },
        showDetail(id, row) {
            this.formId = id;
            this.formData = row;
            this.formProcess = "detail";
            this.formType = "show";
            this.$refs.detailFormModal.$refs.commonModal.show();
        },
        showDetailSuccess() {
            this.$refs.detailFormModal.$refs.commonModal.hide();
            this.getRows();
            this.formClear();
        },
        async sendMessage(message) {
            let formData = {
                message: message,
            }

            const response = await MinorApplicationService.prepSchoolBulkMessage(formData)
                .catch((e) => {
                    this.showErrors(e)
                })

            if ('data' in response.data) {
                this.$refs.messageModal.$refs.commonModal.hide()
                this.$toast.success(this.$t("message_sent_student", { number: response.data.data }));
            }
        },
    },
};
</script>
